import { ListPaginationMeta } from "utils/helpers/pagination";

export interface BackWallTypeRow {
  id: string;
  backWallCode: string;
  backWallDesc: string;
  bump: number;
}

export interface BackWallTypeForm {
  backWallCode: string;
  backWallDesc: string;
  bump: string;
}

export enum FieldType {
  String = "string",
  Number = "number",
}

export const FieldValues: Record<keyof BackWallTypeForm, FieldType> = {
  backWallCode: FieldType.String,
  backWallDesc: FieldType.String,
  bump: FieldType.Number,
};

export type BackWallTypeListMeta = ListPaginationMeta;

export interface BackWallTypeListResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: Array<{
    backWallCode: string;
    backWallDesc: string;
    bump: number;
  }>;
  meta?: BackWallTypeListMeta;
}

export interface BackWallTypeDetail {
  backWallCode: string;
  backWallDesc: string;
  bump: number;
}

export interface BackWallTypeDetailResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: BackWallTypeDetail;
}

export interface BackWallTypeUpdatePayload {
  id: string;
  backWallDesc: string;
  bump: number;
}

export interface BackWallTypeState {
  loading: boolean;
  saving: boolean;
  list: BackWallTypeRow[];
  page: number;
  perPage: number;
  meta: BackWallTypeListMeta;
  error: string | null;
  detail: BackWallTypeDetail | null;
  detailLoading: boolean;
  detailError: string | null;
  isAddModalOpen: boolean;
  form: BackWallTypeForm;
}
